<template>

    <div>
        <div class="modal fade" style="display: block; opacity: 1;" tabindex="-1" id="modalEditCompetitor">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <a @click="closeModal" href="javascript:void(0)" class="close" data-dismiss="modal" aria-label="Close">
                    <em class="icon ni ni-cross"></em>
                </a>
                <div class="modal-header">
                    <h5 class="modal-title">{{ translations.forms.competitor.title_edit }}</h5>
                </div>
                <div class="modal-body">

                    <div id="form-edit-competitor">

                        <input type="hidden" name="competitor_id" id="competitor_id" v-model="competitorInfo.id" />

                        <div class="form-group row">
                            <div class="col">
                                <label for="firstname">{{ translations.forms.competitor.firstname }}*</label>
                                <input id="firstname" v-model="competitorInfo.firstname" name="firstname" type="text" required="required" class="form-control">
                            </div>
                            <div class="col">
                                <label for="lastname">{{ translations.forms.competitor.lastname }}*</label>
                                <input id="lastname" v-model="competitorInfo.lastname" name="lastname" type="text" required="required" class="form-control">
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col">
                                <label for="email">{{ translations.forms.competitor.email }}*</label>
                                <input id="email" v-model="competitorInfo.email" name="email" type="text" required="required" class="form-control">
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col">
                                <label for="street">{{ translations.forms.competitor.street }}*</label>
                                <input id="street" v-model="competitorInfo.street" name="street" type="text" required="required" class="form-control">
                            </div>

                            <div class="col-3">
                                <label for="number">{{ translations.forms.competitor.number }}*</label>
                                <input id="number" v-model="competitorInfo.number" name="number" type="text" required="required" class="form-control">
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col">
                                <label for="city">{{ translations.forms.competitor.city }}*</label>
                                <input id="city" v-model="competitorInfo.city" name="city" type="text" required="required" class="form-control">
                            </div>

                            <div class="col-3">
                                <label for="zipcode">{{ translations.forms.competitor.zipcode }}*</label>
                                <input id="zipcode" v-model="competitorInfo.zipcode" name="zipcode" type="text" required="required" class="form-control">
                            </div>

                            <div class="col-3">
                                <label for="country">{{ translations.forms.competitor.country }}*</label>
                                <input id="country" v-model="competitorInfo.country" name="country" type="text" required="required" class="form-control">
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-3">
                                <label for="nationality">{{ translations.forms.competitor.nationality }}*</label>
                                <input id="nationality" v-model="competitorInfo.nationality" name="nationality" type="text" required="required" class="form-control">
                            </div>

                            <div class="col-3">
                                <label for="language">{{ translations.forms.competitor.language }}*</label>
                                <input id="language" v-model="competitorInfo.language" name="language" type="text" required="required" class="form-control">
                            </div>

                            <div class="col">
                                <label for="mobile_number">{{ translations.forms.competitor.mobile_number }}*</label>
                                <input id="mobile_number" v-model="competitorInfo.mobile_number" name="mobile_number" type="text" required="required" class="form-control">
                            </div>
                        </div>

                        <hr>

                        <div class="form-group row">
                            <div class="col-3">
                                <label for="day_license">{{ translations.forms.competitor.day_license }}</label>
                                <div class="g">
                                    <div class="custom-control custom-control-sm custom-checkbox">
                                        <input type="checkbox" class="custom-control-input" id="day_license" v-model="competitorInfo.day_license">
                                        <label class="custom-control-label" for="day_license"></label>
                                    </div>
                                </div>
                            </div>

                            <div class="col-3">
                                <label for="license_number">{{ translations.forms.competitor.license_number }}</label>
                                <input id="license_number" v-model="competitorInfo.license_number" name="license_number" type="text" class="form-control" placeholder="WXXXXR">
                            </div>

                            <div class="col">
                                <label for="club">{{ translations.forms.competitor.club }}</label>
                                <input id="club" v-model="competitorInfo.club" name="club" type="text" class="form-control">
                            </div>
                        </div>

                    </div>

                </div>
                <div class="modal-footer bg-light">
                    <button type="button" @click="saveCompetitor" class="btn btn-success">{{ translations.forms.competitor.save }}</button>
                </div>
            </div>
        </div>
    </div>
        <div class="modal-backdrop fade show"></div>
    </div>

</template>

<script>
    export default {
        name: 'editCompetitorModal',
        props: [
            'competitor',
            'translations',
        ],

        data() {
            return {
                competitorInfo: {},
            }
        },

        mounted() {
            this.competitorInfo = this.competitor;
        },

        methods: {
            saveCompetitor() {
                this.$emit('onSave', this.competitorInfo);
            },
            closeModal() {
                this.$emit('closeModal');
            }
        }
    }
</script>
